import {
  EDITOR_ASSETS,
  EDITOR_TYPES,
  USER_TYPES,
} from "../../constants/index.js";
import { ENDPOINTS } from "../../constants/apiurl.js";
import {
  decompressFromBase64,
  scalePages,
} from "../../common-functions/index.js";
import { apiPost, apiGet } from "../../common-services/apiCall.js";
import { store } from "../../../../store/store";

export const getUserDetails = () => {
  const stateUser = store.getState()?.projectSetup?.userDetails;
  if (stateUser) {
    return stateUser;
  }

  try {
    if (typeof window !== "undefined") {
      const cachedUser = window.localStorage.getItem("userDetails");
      return cachedUser ? JSON.parse(cachedUser) : null;
    }
  } catch (error) {
    console.error("Failed to read userDetails from localStorage", error);
  }

  return null;
}

export const processThemeResponseItems = (
  response,
  width,
  height,
  orientation,
  editorType
) => {
  // lets get the items theme having orientation match with the current orientation, else default to first theme
  const themeList = response.items?.theme;
  if (!themeList || themeList.length === 0) {
    // Return null instead of throwing to allow graceful handling in the UI
    return null;
  }
  const theme =
    themeList.find((item) => item.orientation === orientation) ||
    themeList[0];

  const decompressedTheme = decompressFromBase64(theme.pages_c);

  // loop through each page and scale the layout to fit the canvas
  const pages = scalePages(
    decompressedTheme.pages,
    width / (editorType === EDITOR_TYPES.PHOTOBOOK ? 2 : 1),
    height
  );

  return {
    ...response.items,
    pages_c: pages,
  };
};
export const processProjectPages = (encoded_pages, width, height) => {
  if (width == undefined || width == null) {
    return [];
  }
  const decompressedThemePages = decompressFromBase64(encoded_pages);

  // loop through each page and scale the layout to fit the canvas
  const pages = scalePages(decompressedThemePages.pages, width, height);

  // Preserve isPageEdited flag from API data if present
  pages.forEach((page, index) => {
    if (decompressedThemePages.pages[index]?.isPageEdited !== undefined) {
      page.isPageEdited = decompressedThemePages.pages[index].isPageEdited;
    } else {
      page.isPageEdited = false;
    }
  });

  return pages;
};

export const GetThemeById = async (id, canvasSize, editorType, orientation) => {
  // const user = JSON.parse(localStorage.getItem("userDetails"));
  const user = getUserDetails();
  // apiGet is asycn function which will return  ,  i want to return the response from this function
  let data = {
    _id: id,
  };

  if (
    canvasSize &&
    canvasSize.width &&
    canvasSize.width !== null &&
    canvasSize.width !== undefined &&
    canvasSize.height &&
    canvasSize.height !== null &&
    canvasSize.height !== undefined &&
    user &&
    user?.userTypeCode === USER_TYPES.CUSTOMER
    && editorType !== EDITOR_TYPES.CUSTOME_PRODUCT
  ) {
    data.size = `${canvasSize.width}x${canvasSize.height}`;
  }
  data.user_type_code = user ? user?.userTypeCode : null;
  const response = await apiPost(ENDPOINTS.getThemeById, data);
  if (response && response.status !== 0) {
    // Use the first theme's dimensions for scaling — ensures correct sizing
    // regardless of what the current canvasSize is (may still be default 1200x2400)
    let baseWidth = canvasSize.width;
    let baseHeight = canvasSize.height;
    const baseDepth = canvasSize.depth || 0;
    if (response?.items?.theme?.length > 0) {
      baseWidth = parseFloat(response.items?.theme[0]?.width) || baseWidth;
      baseHeight = parseFloat(response.items?.theme[0]?.height) || baseHeight;
    }

    let width = baseWidth - baseDepth;
    let height = baseHeight - baseDepth;
    const themeData = await processThemeResponseItems(
      response,
      width,
      height,
      orientation,
      editorType
    );
    return themeData;
  } else {
    return null;
  }
};
